module.exports = __webpack_public_path__ + "static/media/Discovery-Success.8e102f9b.svg";